import CaseIcon from '@components/icons/case-icon'
import { TAlert, TIncident, TServiceRequest } from '@core/modules/mdr/cases'
import Typography from '@/ui/components/typography'
import { DrawerHeaderConfig } from '@/ui/drawer/common/DrawerNavigationHeader'
import { CaseMetaRow } from '@/ui/drawer/common/CaseMetaRow'
import { LabelRow } from '@/ui/drawer/common/drawerHeaderShared.styles'
import { CaseDrawerHeaderBadges } from './CaseDrawerHeaderBadges'

const CASE_TYPE_LABELS: Record<string, string> = {
    incident: 'Incident',
    alert: 'Alert',
}

const getCaseTypeLabel = (caseType?: string): string =>
    CASE_TYPE_LABELS[caseType?.toLowerCase() ?? ''] ?? caseType ?? 'Case'

export const caseDrawerHeaderConfig: DrawerHeaderConfig<TIncident | TAlert> = {
    itemsKey: 'cases',
    indexKey: 'currentIndex',
    icon: (c) => <CaseIcon caseType={c?.caseType?.toLowerCase() ?? ''} />,
    label: (c) => (
        <LabelRow>
            <Typography variant="m-regular">
                {getCaseTypeLabel(c?.caseType)}
            </Typography>
            {c && (
                <CaseDrawerHeaderBadges
                    severity={c.severity}
                    status={c.status}
                    variant="incident"
                />
            )}
        </LabelRow>
    ),
    title: (c) => c?.title ?? 'Case details',
    meta: (c) =>
        c ? (
            <CaseMetaRow createdAt={c.createdAt} caseNumber={c.caseNumber} />
        ) : null,
}

export const serviceRequestDrawerHeaderConfig: DrawerHeaderConfig<TServiceRequest> =
    {
        itemsKey: 'cases',
        indexKey: 'currentIndex',
        icon: () => <CaseIcon caseType="serviceRequest" />,
        label: (c) => (
            <LabelRow>
                <Typography variant="m-regular">Service request</Typography>
                {c && (
                    <CaseDrawerHeaderBadges
                        status={c.status}
                        variant="serviceRequest"
                    />
                )}
            </LabelRow>
        ),
        title: (c) => c?.title ?? 'Service request',
        meta: (c) =>
            c ? (
                <CaseMetaRow
                    createdAt={c.createdAt}
                    lastModifiedAt={c.lastModifiedAt}
                    caseNumber={c.caseNumber}
                    variant="serviceRequest"
                />
            ) : null,
    }
